import React from "react";
import { Link } from "react-router-dom";
import { CLAIM_TYPES, TYPE_TONE, SHORT, LEVEL, LEVEL_DOT, SURVEYOR_TYPES, days } from "@/lib/claims";

export const TypePill = ({ type, testid }) => <span data-testid={testid} className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-bold whitespace-nowrap ${TYPE_TONE[type] || "bg-slate-800 text-slate-300 border-slate-700"}`}>{CLAIM_TYPES[type] || type}</span>;

export const SurveyorPill = ({ type }) => (type ? <span className={`inline-flex rounded px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider ${type === "sje" ? "bg-amber-500/15 text-amber-300" : "bg-slate-700/60 text-slate-300"}`}>{SURVEYOR_TYPES[type]}</span> : <span className="text-slate-600">—</span>);

// Current stage + how long it has sat there, coloured by aging level
export const StatusPill = ({ status, aging, full = false, testid }) => {
  const lvl = aging?.level || "ok";
  return (
    <span data-testid={testid} className="inline-flex items-center gap-1.5 whitespace-nowrap">
      <span className={`w-2 h-2 rounded-full shrink-0 ${LEVEL_DOT[lvl]} ${lvl === "alert" ? "animate-pulse" : ""}`} />
      <span className={`text-xs font-semibold ${lvl === "done" ? "text-emerald-300" : "text-slate-200"}`}>{full ? status : SHORT[status] || status}</span>
      {aging && lvl !== "done" && <span className={`text-[11px] font-mono-num ${LEVEL[lvl]}`}>· {days(aging.days_at_stage)}</span>}
    </span>
  );
};

export const PayPill = ({ computed }) => (computed?.payment_status === "received" ? <span className="text-[11px] font-bold text-emerald-300">Received</span> : <span className="text-[11px] font-bold text-amber-300">Not received</span>);

export const ClaimLink = ({ c, className = "" }) => <Link to={`/claims/${c.id}`} data-testid={`claim-link-${c.id}`} className={`font-mono-num text-rose-300 hover:underline ${className}`}>{c.claim_number}</Link>;
